import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { loginWithAuth0 } from '@/providers/authProvider';

export const CustomLoginPage = () => {
  const handleGoogleLogin = () => {
    loginWithAuth0();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#1a1a1a',
        padding: '24px',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#2a2a2a',
          padding: '48px',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
          maxWidth: '400px',
          width: '100%',
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: '#fff',
            marginBottom: '32px',
            textAlign: 'center',
            fontWeight: 600,
          }}
        >
          Admin Login
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            color: '#ccc',
            marginBottom: '32px',
            textAlign: 'center',
          }}
        >
          Sign in with your getmoments.app Google account
        </Typography>

        <Button
          onClick={handleGoogleLogin}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: '#4285f4',
            color: '#fff',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 500,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#357ae8',
            },
          }}
        >
          Continue with Google
        </Button>
      </Box>
    </Box>
  );
};

